<template>
  <div class="navbar">
    <hamburger :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb class="breadcrumb-container" />

    <div class="right-menu">
      <!-- <el-button type="text" icon="el-icon-switch-button" @click="logout">退出</el-button> -->
      <el-dropdown class="avatar-container" trigger="click">
        <div style="cursor: pointer;">
          <i class="el-icon-user-solid"></i>
          <span style="margin:0 10px">{{ userInfo?.userName || ''}} </span>
          <i class="el-icon-caret-bottom" />
        </div>
        
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link to="/user-set">
            <el-dropdown-item  >
              <el-button type="text" icon="el-icon-edit" class="text-333">修改密码</el-button>
            </el-dropdown-item>
          </router-link>
          
          <el-dropdown-item divided @click.native="logout">
            <el-button type="text" icon="el-icon-switch-button" class="text-333">退出</el-button>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'

import { getSysUser ,myMenuAndBtn} from '@/api/login'
export default {
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar'
    ])
  },
  data(){
    return{
      userInfo:null
    }
  },
  created(){
    
    this.getUserInfo()
    this.getMyMenuAndBtn()
    
  },
  methods: {
   
    getMyMenuAndBtn(){
       myMenuAndBtn().then(res=>{
        const {data} = res
        if(res.code !==200) return
        sessionStorage.setItem('MENU',JSON.stringify(data))
      })
    },
    getUserInfo(){
      getSysUser().then(res=>{
        const {data} = res
        if(res.code !==200) return
        this.userInfo = data
        
        sessionStorage.setItem('USER',JSON.stringify(data))
      })
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    logout(){
      sessionStorage.removeItem('TOKEN')
      sessionStorage.removeItem('USER')
      sessionStorage.removeItem('MENU')
      sessionStorage.clear()
      this.$router.push('/login')
    }
    
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    margin-right: 20px;
    // &:focus {
    //   outline: none;
    // }

    // .right-menu-item {
    //   display: inline-block;
    //   padding: 0 8px;
    //   height: 100%;
    //   font-size: 18px;
    //   color: #5a5e66;
    //   vertical-align: text-bottom;

    //   &.hover-effect {
    //     cursor: pointer;
    //     transition: background .3s;

    //     &:hover {
    //       background: rgba(0, 0, 0, .025)
    //     }
    //   }
    // }

    // .avatar-container {
    //   margin-right: 30px;

    //   .avatar-wrapper {
    //     // margin-top: 5px;
    //     position: relative;

    //     .user-avatar {
    //       cursor: pointer;
    //       width: 40px;
    //       height: 40px;
    //       border-radius: 10px;
    //     }

    //     .el-icon-caret-bottom {
    //       cursor: pointer;
    //       position: absolute;
    //       right: -20px;
    //       top: 25px;
    //       font-size: 12px;
    //     }
    //   }
    // }
  }
}

</style>
